module.exports = __webpack_public_path__ + "static/studio_leon_gray-8be1ebd402fdacca0b0af249026b2b56.svg";